module.exports = __webpack_public_path__ + "img/kuliaria.9325f2cd.jpeg";